var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-notifier flex-all-centered-row"},[_vm._v("\n    "+_vm._s(_vm.count)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }